export const getInitialEmailSyncTimeZone = ({
	tenantTimeZone,
	timeZones = [],
}) => {
	const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const isBrowserTimeZoneSupported = timeZones.some(
		(timeZone) => timeZone.value === browserTimeZone
	);

	if (tenantTimeZone === 'UTC' && isBrowserTimeZoneSupported) {
		return browserTimeZone;
	}

	return tenantTimeZone;
};
